import {
   EmergencyNotificationConfigurationSimple,
   EmergencyNotificationConfigurationSimpleQuery,
} from '@dreryk/egabinet-emergency-notification-frontend-api';

import { UserBarGroup, UserBarGroupLinkWrap } from '@dreryk/react-components';
import { useCqrsFind } from '@dreryk/command-query-react-common';
import { isDemo } from '@dreryk/demo-variant-frontend';

import { protectFeature } from '~libs.shared.system';

import { EmergencyNotificationAcknowledgedEventListener } from './EmergencyNotificationEventListener';
import { EmergencyNotificationButton } from './EmergencyNotificationButton';
import { EmergencyNotificationTrigger } from './EmergencyNotificationTrigger';
import { EmergencyNotificationDismiss } from './EmergencyNotificationDismiss';

export const EmergencyNotificationUserBarGroup = (): JSX.Element | null => {
   const { data: emergencyNotificationConfiguration } = useCqrsFind<EmergencyNotificationConfigurationSimple>(
      () => {
         return new EmergencyNotificationConfigurationSimpleQuery();
      },
      {
         enabled: protectFeature('creatingVisits', !isDemo(), false),
      }
   );

   if (!emergencyNotificationConfiguration?.emergencyNotificationEnabled) {
      return null;
   }

   return (
      <UserBarGroup testId={'emergencyNotification'}>
         <UserBarGroupLinkWrap testId={'emergencyNotification'}>
            <EmergencyNotificationButton variant={'real'} />
            <EmergencyNotificationTrigger />
            <EmergencyNotificationDismiss />
            <EmergencyNotificationAcknowledgedEventListener />
         </UserBarGroupLinkWrap>
      </UserBarGroup>
   );
};
